import { useState } from 'react'

import Box from '@mui/material/Box'

import type { GebiedLabel } from '@models/GebiedLabel'

import type { AuthenticatedUser } from '../../auth/types/AuthenticatedUser'
import { groupLabelsByGebied } from '../util/label-util'

import { GebiedLabelCard } from './GebiedLabelCard'
import { CreateLabel } from './dialogs/CreateLabel'
import { DeleteLabel } from './dialogs/DeleteLabel'

export { GebiedLabels }

type Props = {
  user: AuthenticatedUser
  labels: GebiedLabel[]
}

const GebiedLabels = ({ user, labels }: Props) => {
  const { canViewBeheer, canCreateLabel, organisatie } = user
  const [selected, setSelected] = useState<GebiedLabel[] | null>(null)
  const [teVerwijderen, setTeVerwijderen] = useState<GebiedLabel | null>(null)

  const mayManageLabelsFor = (verantwoordelijke: string) =>
    canCreateLabel && (canViewBeheer || verantwoordelijke === organisatie)

  return (
    <>
      <Box>
        {groupLabelsByGebied(labels).map((gebiedLabels, index) => (
          <GebiedLabelCard
            key={gebiedLabels[0].gebiedscode}
            expanded={index === 0}
            labels={gebiedLabels}
            mayManageLabels={mayManageLabelsFor(
              gebiedLabels[0].verantwoordelijke,
            )}
            onClickCreateLabel={() => setSelected(gebiedLabels)}
            onClickDeleteLabel={setTeVerwijderen}
          />
        ))}
      </Box>

      {selected && (
        <CreateLabel labels={selected} onClose={() => setSelected(null)} />
      )}

      {teVerwijderen && (
        <DeleteLabel
          label={teVerwijderen}
          onClose={() => setTeVerwijderen(null)}
        />
      )}
    </>
  )
}
